import React from "react"
import PropTypes from "prop-types"
import Link from "./Link"
import { Button } from "./Button"
import { ArrowRightIcon } from "@heroicons/react/20/solid"

const CategoryCard = ({ data }) => {
  const { slug, title, excerpt, image } = data

  return (
    <div className={`sm:flex lg:flex-col p-12 bg-gray-100 gap-16`}>
      <div className={`space-y-4`}>
        <Link to={`/blog/${slug}`}>
          <div className={`flex space-x-4`}>
            <p className={`text-3xl font-bold sm:text-4xl text-gray-900`}>
              {title}
            </p>
            <Button
              type="ghost"
              size="none"
              icon={<ArrowRightIcon className="h-8 w-8" aria-hidden="true" />}
            ></Button>
          </div>
        </Link>
        <p className={`text-base sm:text-lg text-gray-900`}>
          {excerpt.excerpt}
        </p>
      </div>
      <img alt={image.title} src={image.file.url} />
    </div>
  )
}
CategoryCard.propTypes = {
  data: PropTypes.object,
}
export default CategoryCard
